var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.318182,
    y: 0.318182,
    width: 27.3636,
    height: 27.3636,
    rx: 13.6818,
    stroke: "#D9DEE2",
    strokeWidth: 0.636364
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0125 19.4283C12.5298 19.4283 11.047 19.1928 9.64067 18.7219C9.10612 18.5374 8.69885 18.1619 8.52067 17.6719C8.33613 17.1819 8.39976 16.641 8.69249 16.1574L9.42431 14.9419C9.57703 14.6874 9.71703 14.1783 9.71703 13.8792V12.0401C9.71703 9.67281 11.6452 7.74463 14.0125 7.74463C16.3798 7.74463 18.3079 9.67281 18.3079 12.0401V13.8792C18.3079 14.1719 18.4479 14.6874 18.6007 14.9483L19.3261 16.1574C19.5998 16.6155 19.6507 17.1692 19.4661 17.6719C19.2816 18.1746 18.8807 18.5564 18.3779 18.7219C16.9779 19.1928 15.4952 19.4283 14.0125 19.4283ZM14.0125 8.69917C12.1734 8.69917 10.6716 10.1946 10.6716 12.0401V13.8792C10.6716 14.3437 10.4807 15.031 10.2452 15.4319L9.5134 16.6474C9.3734 16.8828 9.33522 17.131 9.41794 17.341C9.49431 17.5574 9.68522 17.7228 9.94613 17.8119C12.6061 18.7028 15.4252 18.7028 18.0852 17.8119C18.3143 17.7355 18.4925 17.5637 18.5752 17.3346C18.6579 17.1055 18.6389 16.8574 18.5116 16.6474L17.7798 15.4319C17.5379 15.0183 17.3534 14.3374 17.3534 13.8728V12.0401C17.3534 10.1946 15.8579 8.69917 14.0125 8.69917Z",
    fill: "#111826",
    stroke: "black",
    strokeWidth: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1967 8.87099C15.1522 8.87099 15.1076 8.86462 15.0631 8.8519C14.8785 8.80099 14.7003 8.76281 14.5285 8.73735C13.9876 8.66735 13.4658 8.70553 12.9758 8.8519C12.7976 8.90917 12.6067 8.8519 12.4858 8.71826C12.3649 8.58462 12.3267 8.39372 12.3967 8.2219C12.6576 7.55372 13.294 7.11462 14.0194 7.11462C14.7449 7.11462 15.3812 7.54735 15.6422 8.2219C15.7058 8.39372 15.674 8.58462 15.5531 8.71826C15.4576 8.82008 15.324 8.87099 15.1967 8.87099Z",
    fill: "#111826",
    stroke: "black",
    strokeWidth: 0.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0123 20.879C13.3823 20.879 12.7714 20.6245 12.326 20.179C11.8805 19.7336 11.626 19.1227 11.626 18.4927H12.5805C12.5805 18.8681 12.7332 19.2372 13.0005 19.5045C13.2678 19.7718 13.6369 19.9245 14.0123 19.9245C14.8014 19.9245 15.4442 19.2818 15.4442 18.4927H16.3987C16.3987 19.8099 15.3296 20.879 14.0123 20.879Z",
    fill: "#111826",
    stroke: "black",
    strokeWidth: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.69b65234c4ff06f484846b56b722e012.svg";
export { ForwardRef as ReactComponent };